import { render, staticRenderFns } from "./user-address-card.vue?vue&type=template&id=7a749bfc&scoped=true&lang=pug&"
import script from "./user-address-card.vue?vue&type=script&lang=js&"
export * from "./user-address-card.vue?vue&type=script&lang=js&"
import style0 from "./user-address-card.vue?vue&type=style&index=0&id=7a749bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a749bfc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/widgets/image.vue').default})
